import { g as global$1 } from './index.esm-7182addc.js';
import './index-d4808923.js';

var _a;
let disableWarnings = !!((_a = global$1.gravityConfig) === null || _a === void 0 ? void 0 : _a.disableWarnings);
/**
 * Global config
 * @typedef {Object} Config
 * @property {boolean} disableWarnings - Flag to disable console warnings
 */
const config = {
    get disableWarnings() {
        return disableWarnings;
    },
    set disableWarnings(value) {
        disableWarnings = value;
    },
};
// Makes the config available
global$1.gravityConfig = config;
const config$1 = config;

export { config$1 as config };

//# sourceMappingURL=index.js.map